import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import useFileValidator from 'hooks/useFileValidator';

import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import { useSetAtom } from 'jotai';
import modalInformationAtom from 'atom/modalInformationAtom';

interface Props {
  onChangeFile: (file: any) => void;
  file: any;
  isRemove?: boolean;
  onClick?: (e: any) => void;
}

export default function UploadInput({ onChangeFile, file, isRemove = true, onClick }: Props) {
  const setModalInformation = useSetAtom(modalInformationAtom);
  const { error, validateFile } = useFileValidator();
  const inputRef = useRef<HTMLInputElement>(null);

  const location = useLocation();

  const onChange = (event: any) => {
    const file = event?.target?.files[0];
    if (file) {
      validateFile(file);
      if (error) {
        onRemove();
        return setModalInformation({
          type: 'FILE_ERROR'
        });
      } else {
        onChangeFile(file);
      }
    }
  };

  const onRemove = () => {
    onChangeFile(null);
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  return (
    <UploadInputWrapper>
      <ButtonWrapper>
        첨부
        <FileInput
          type="file"
          onChange={onChange}
          accept=".jpg, .jpeg, .png, .pdf"
          ref={inputRef}
        />
      </ButtonWrapper>
      {file && (
        <FileName>
          {location.pathname === '/mypage' ? (
            <div style={{ cursor: 'pointer' }} onClick={onClick}>
              {file?.name || file}
            </div>
          ) : (
            <>{file?.name || file}</>
          )}

          {isRemove && <RemoveBtn onClick={onRemove}>삭제</RemoveBtn>}
        </FileName>
      )}
    </UploadInputWrapper>
  );
}

const UploadInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const ButtonWrapper = styled.label`
  display: inline-block;
  border-radius: 24px;
  background: ${color.black2};
  ${font.caption2_medium};
  color: ${color.white};
  padding: 8px 12px;
  cursor: pointer;
  &:focus,
  &:hover {
    box-shadow: 0px 0px 0px 4px rgb(220, 220, 220);
    outline: none;
  }
`;

const FileInput = styled.input`
  display: none;
`;

const opacity = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const FileName = styled.div`
  animation: ${opacity} 1.5s;
`;

const RemoveBtn = styled.button`
  color: ${color.gray500};
  ${font.caption1_medium};
  margin-left: 16px;
`;
